const LOCAL_OCX_URL = 'http://127.0.0.1:55661/';
const LOCAL_OCX_TIMEOUT = 6000;

function buildGetUserListPayload() {
  return {
    funcid: 5,
    ReturnMethod: 0,
  };
}

function buildDecryptPayload(containerName, inData) {
  return {
    funcid: 20,
    ContainerName: containerName,
    InData: inData,
  };
}

function ensureValue(value, message) {
  if (!value) {
    throw new Error(message);
  }
  return value;
}

function getPrimaryContainerName(response) {
  const result = response && response.Result;
  if (!Array.isArray(result) || !result.length || typeof result[0] !== 'string') {
    throw new Error('未识别到可用证书容器');
  }

  const container = result[0];
  const parts = container.split('||');
  return ensureValue(parts[1] || parts[0], '未识别到可用证书容器');
}

function extractDecryptData(response) {
  const decrypted = response && response.Result && response.Result.DecryptData;
  return ensureValue(decrypted, '本地控件解密结果为空');
}

function decodeBase64Utf8(value) {
  if (typeof value !== 'string') {
    return '';
  }

  const normalized = value.trim();
  if (!normalized || normalized.length % 4 !== 0 || !/^[A-Za-z0-9+/]+={0,2}$/.test(normalized)) {
    return '';
  }

  try {
    if (typeof Buffer !== 'undefined') {
      const decoded = Buffer.from(normalized, 'base64').toString('utf8');
      const encodedAgain = Buffer.from(decoded, 'utf8')
        .toString('base64')
        .replace(/=+$/, '');
      if (encodedAgain !== normalized.replace(/=+$/, '')) {
        return '';
      }
      return decoded;
    }

    const binary = atob(normalized);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }

    if (typeof TextDecoder !== 'undefined') {
      return new TextDecoder('utf-8').decode(bytes);
    }

    return decodeURIComponent(escape(binary));
  } catch (error) {
    return '';
  }
}

function buildEnvelopeDecryptCandidates(encryptedEnvelope) {
  const rawEnvelope = ensureValue(encryptedEnvelope, '数字信封为空');
  const candidates = [ rawEnvelope ];
  const decodedEnvelope = decodeBase64Utf8(rawEnvelope);

  if (decodedEnvelope && decodedEnvelope !== rawEnvelope) {
    candidates.push(decodedEnvelope);
  }

  return candidates;
}

function buildGuangzhengRequestData(applyNo, decryptedEnvelopeRaw) {
  ensureValue(decryptedEnvelopeRaw, 'CA解密结果为空');

  let requestData;
  try {
    requestData = JSON.parse(decryptedEnvelopeRaw);
  } catch (error) {
    requestData = {
      type: 'tbaohan',
      applyno: applyNo,
      encryptkey: decryptedEnvelopeRaw,
    };
  }

  if (
    requestData.type !== 'tbaohan' ||
    !requestData.applyno ||
    !requestData.encryptkey
  ) {
    throw new Error('CA解密结果缺少必要字段');
  }

  return requestData;
}

function normalizeLocalOcxError(error) {
  if (!error) {
    return new Error('本地控件解密失败');
  }

  if (/ERR_CONNECTION_REFUSED|Failed to load|NetworkError|通讯失败|未初始化/i.test(error.message || '')) {
    return new Error('本地控件未启动或驱动未安装');
  }

  return error instanceof Error ? error : new Error(String(error));
}

function createXhr() {
  if (typeof XMLHttpRequest === 'undefined') {
    throw new Error('当前环境不支持本地控件请求');
  }
  return new XMLHttpRequest();
}

function postLocalOcx(payload) {
  return new Promise((resolve, reject) => {
    let xhr;
    try {
      xhr = createXhr();
    } catch (error) {
      reject(normalizeLocalOcxError(error));
      return;
    }

    xhr.open('POST', LOCAL_OCX_URL, true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.timeout = LOCAL_OCX_TIMEOUT;

    xhr.onload = function onload() {
      if (xhr.status !== 200) {
        reject(normalizeLocalOcxError(new Error('本地控件通讯失败')));
        return;
      }

      try {
        resolve(JSON.parse(xhr.responseText));
      } catch (error) {
        reject(new Error('本地控件返回数据格式异常'));
      }
    };

    xhr.onerror = function onerror() {
      reject(normalizeLocalOcxError(new Error('NetworkError')));
    };

    xhr.ontimeout = function ontimeout() {
      reject(new Error('本地控件响应超时'));
    };

    xhr.send(JSON.stringify(payload));
  });
}

function decryptWithLocalOcx(encryptedEnvelope) {
  return postLocalOcx(buildGetUserListPayload())
    .then(getPrimaryContainerName)
    .then(containerName => {
      return postLocalOcx(buildDecryptPayload(containerName, encryptedEnvelope));
    })
    .then(extractDecryptData)
    .catch(error => {
      throw normalizeLocalOcxError(error);
    });
}

function decryptWithFallback(encryptedEnvelope, handlers) {
  const localDecrypt = handlers && handlers.localDecrypt;
  const iwebDecrypt = handlers && handlers.iwebDecrypt;

  return Promise.resolve()
    .then(() => localDecrypt(encryptedEnvelope))
    .then(result => ensureValue(result, '本地控件解密结果为空'))
    .catch(localError => {
      return Promise.resolve()
        .then(() => iwebDecrypt(encryptedEnvelope))
        .then(result => ensureValue(result, 'CA锁解密结果为空'))
        .catch(fallbackError => {
          const error = new Error('本地控件与CA锁解密均失败');
          error.localError = localError;
          error.fallbackError = fallbackError;
          throw error;
        });
    });
}

function decryptEnvelopeWithFallback(encryptedEnvelope, handlers) {
  const candidates = buildEnvelopeDecryptCandidates(encryptedEnvelope);
  const errors = [];

  return candidates.reduce((promise, candidate) => {
    return promise.catch(() => {
      return decryptWithFallback(candidate, handlers).catch(error => {
        errors.push(error);
        throw error;
      });
    });
  }, Promise.reject(new Error('start'))).catch(() => {
    const error = new Error('本地控件与CA锁解密均失败');
    error.attemptErrors = errors;
    error.localError = errors[errors.length - 1] && errors[errors.length - 1].localError;
    error.fallbackError = errors[errors.length - 1] && errors[errors.length - 1].fallbackError;
    throw error;
  });
}

function buildBztQrcodeParams(orderNo) {
  return {
    orderNo: ensureValue(orderNo, '订单号为空'),
  };
}

function buildBztQueryParams(orderNo, qrcodeid) {
  return {
    orderNo: ensureValue(orderNo, '订单号为空'),
    qrcodeid: ensureValue(qrcodeid, '标证通二维码编号为空'),
  };
}

function extractBztQrContent(responseData) {
  const qrInfo = responseData && responseData.qrInfo;
  return {
    qrcodeid: ensureValue(qrInfo && qrInfo.qrcodeid, '标证通二维码编号为空'),
    content: ensureValue(qrInfo && qrInfo.content, '标证通二维码内容为空'),
  };
}

module.exports = {
  LOCAL_OCX_URL,
  buildGetUserListPayload,
  buildDecryptPayload,
  getPrimaryContainerName,
  extractDecryptData,
  decodeBase64Utf8,
  buildEnvelopeDecryptCandidates,
  buildGuangzhengRequestData,
  buildBztQrcodeParams,
  buildBztQueryParams,
  extractBztQrContent,
  decryptWithLocalOcx,
  decryptWithFallback,
  decryptEnvelopeWithFallback,
};
